import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionData } from "../../utils/sessionManager";

const initialState: SessionData = {
  sessionId: "",
  prevSessionId: "",
  callCount: 0,
  createdAt: 0,
  maxCalls: 3,
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionData>) => {
      return action.payload;
    },
  },
});

export const { setSession } = sessionSlice.actions;

export default sessionSlice.reducer;
